/* eslint-disable no-useless-escape */
import 'babel-polyfill';
import React, { Component, Fragment } from 'react';
import {
  Input,
  Affix,
  Row,
  Col,
  message,
  Button,
  notification,
  Tag,
  Drawer,
} from 'antd';
import { Map } from 'immutable';
import 'draft-js/dist/Draft.css';
import {
  Editor,
  EditorState,
  getDefaultKeyBinding,
  ContentState,
  Modifier,
  Entity,
  SelectionState,
} from 'draft-js';
import { DecoDictionary } from 'components/decorators';
import { DecosFunc } from 'components/utils';
import { connect } from 'react-redux';
import { BaseInfo } from 'components/menu/RightMenu/informations';
import { withRouter } from 'react-router-dom';
import * as services from 'services';
import * as actions from 'actions';
import * as gens from 'components/decorators/generators';
import { sample1, sample2, sample3, sample4 } from './sample';
const WORDS_DELAY = 1200;
const LQINFOS_DELAY = 5000;
const TEXTS_DELAY = 1200;

let wordstimer, textstimer, lqinfostimer;
let root;

const mapStateToProps = (state) => ({
  div: state.hanjas.div,
  highlights: state.searchDeco.highlights,
  decos: state.spell.decos,
  synos: state.syno.synos,
  dialects: state.dialect.dialects,
  searchFilter: state.spell.searchFilter,
  selectMenu: state.menu.selectMenu,
  replaceItem: state.spell.replaceItem,
  status: state.spell.status,
  filters: state.syno.filters,
  dialectFilters: state.dialect.dialectFilters,
  multioptions: state.multilang.multioptions,
  activeIndex: state.difficulty.activeIndex,
  blocks: state.difficulty.blocks,
  selectedItem: state.spell.selectedItem,
  lqInfos: state.info.lqInfos,
  user: state.auth.user,
});

message.config({
  top: 100,
  duration: 2,
  maxCount: 3,
});

const info = () => {
  message.info('문서를 분석 중입니다.');
};

const info2 = () => {
  message.info(
    '단어를 더블 클릭하시면 단어의 뜻풀이 정보를 확인하실 수 있습니다.'
  );
};

const close = () => {
  //console.log('Notification was closed. Either the close button was clicked or duration time elapsed.');
};

const gotoStdDictionary = (board, word_no, key) => {
  if (word_no != null && root != null) {
    if (root.state.selectMenu === '6') {
      root.props.history.push({
        pathname: '/sentence/' + board + '/decos/synonyms',
        post: { dicCode: 'dic-std', word_no },
      });
    } else {
      root.showDrawer(word_no);
    }
  }
  notification.close(key);
};

const fetchStdInfos = async (datas) => {
  const sendDatas = datas.map((x) => {
    return { word_no: x.WORD_NO, sup_no: x.WEB_SUP };
  })[0];
  const post = await services.postApi(this, '/api/sentence/stdInfo', sendDatas);
  if (post && post.status === 200) {
    return post.data;
  }
  return null;
};

const openNotification = async (board, datas) => {
  const results = await fetchStdInfos(datas);
  if (
    results.datas == null ||
    (results.datas != null && results.datas.length === 0)
  )
    return;
  const key = 'noti';
  const btn = (
    <Button
      type="primary"
      size="small"
      onClick={() => gotoStdDictionary(board, results.datas[0].WORD_NO, key)}>
      꼬마사전 더보기
    </Button>
  );
  notification.open({
    message: (
      <div>
        {datas[0].CD_WORD}
        {datas[0].ORG_LANGUAGE && '(' + datas[0].ORG_LANGUAGE + ')'}
      </div>
    ),
    description: (
      <div>
        <Row type="flex">
          <Col>
            <Tag>
              {results.datas[0].PART_SPEECH && results.datas[0].PART_SPEECH}
            </Tag>
          </Col>
          <Col>
            {results.datas[0].DEFINITION && results.datas[0].DEFINITION}
          </Col>
        </Row>
      </div>
    ),
    btn,
    key,
    onClose: close,
    duration: 0,
  });
};

const mapDispatchToProps = (dispatch) => ({
  onDecosView: (broken1) => dispatch(actions.onDecosView(broken1)),
  onChangeText: (text) => dispatch(actions.onChangeText(text)),
  onChangeBlockKey: (blockKeys) =>
    dispatch(actions.onChangeBlockKey(blockKeys)),
  onBlockKeyText: (blockTexts, flag) =>
    dispatch(actions.onBlockKeyText(blockTexts, flag)),
  onDisableItem: (disableItem) => dispatch(actions.onDisableItem(disableItem)),
  onSelectedItem: (selectedItem) =>
    dispatch(actions.onSelectedItem(selectedItem)),
  onMultiLangSelectedText: (selectedText) =>
    dispatch(actions.onMultiLangSelectedText(selectedText)),
  onDocumentsTitleChange: (title) =>
    dispatch(actions.onDocumentsTitleChange(title)),
  onChangeLqInfosText: (lqInfosText) =>
    dispatch(actions.onChangeLqInfosText(lqInfosText)),
});

const styles = {
  root: {
    fontSize: 14,
    padding: 20,
    width: 600,
    color: 'black!important',
  },
  editor: {
    cursor: 'text',
    fontSize: 20,
    padding: 0,
    marginTop: 0,
    marginLeft: 15,
    marginRight: 15,
    marginBottom: 0,
    minHeight: 400,
  },
  controls: {
    fontSize: 25,
    marginBottom: 10,
    userSelect: 'none',
    borderStyle: 'dashed',
    color: '#000',
  },
  styleButton: {
    color: '#999',
    cursor: 'pointer',
    marginRight: 16,
    padding: '2px 0',
  },
};

const customRenderMap = Map({
  unstyled: {
    element: 'div',
    // will be used in convertFromHTMLtoContentBlocks
    aliasedElements: ['p'],
  },
});

const findOne = (datas, key) => {
  const data = datas.filter((item) => item.getKey() === key);
  if (data) return data[0];
  return null;
};

const editor = React.createRef();

class CustomEditors extends Component {
  state = {
    width: 0,
    visible: false,
    placement: 'left',
  };

  showDrawer = (word_no) => {
    this.setState({
      visible: true,
      word_no,
    });
  };

  onCloseDrawer = () => {
    this.setState({
      visible: false,
    });
  };

  onChangeDrawer = (e) => {
    this.setState({
      placement: e.target.value,
    });
  };

  fetchLogSave = async (datas) => {
    await services.postApi(this, '/api/sentence/spell', datas);
    return true;
  };

  fetchOrderUpdate = async () => {
    await services.postApi(this, '/api/used/usedOk', null);
    return true;
  };

  constructor(props) {
    super(props);
    let sample, title;
    switch (this.props.match.params.board) {
      case 'sample1':
        sample = sample1;
        title = '헌법 전문';
        break;
      case 'sample2':
        sample = sample2;
        title = '보도자료';
        break;
      case 'sample3':
        sample = sample3;
        title = '자기 소개서(취업용)';
        break;
      case 'sample4':
        sample = sample4;
        title = '자기 소개서(입시용)';
        break;
      default:
        sample = '';
        title = '';
        break;
    }

    const editorState = EditorState.createWithContent(
      ContentState.createFromText(sample)
    );
    this.state = {
      editorState,
      width: 0,
      wmenu: props.wmenu,
      broken1: props.broken1,
      broken2: props.broken2,
      selectedItem: props.selectedItem,
      title: title,
      text: '',
      titleContents: '',
      textContents: '',
      isPasted: false,
      isReplaced: false,
      changeText: false,
      enterChangeText: false,
      isLoading: false,
      isChangeText: false,
      isChangeLqText: false,
      isChangeWords: false,
      start: false,
      selection: null,
      newText: '',
      change: false,
      isLock: false,
    };

    this.myRef = React.createRef();
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    this.onChange = (editorState) => {
      try {
        const content = editorState.getCurrentContent();
        const newText = content.getPlainText();
        this.setState({ editorState, text: newText });
      } catch (e) {
        //console.log(e);
      }
    };

    /*
		this.setEditor = editor => {
			this.editor = editor;
		};
		*/
    this.focusEditor = () => {
      try {
        if (editor) {
          editor.current.focus();
          editor.current.editor.addEventListener('compositionend', (e) =>
            this.handleEvent(e, this)
          );
        }
      } catch (e) {
        //console.log(e);
      }
    };
    root = this;
  }

  handleEvent(e, callback) {
    if (callback.state.editorState.isInCompositionMode()) {
      this.setState({ compareText: editor.current.editor.innerText });
      if (wordstimer) clearTimeout(wordstimer);
      wordstimer = setTimeout(this.timerTickWords, WORDS_DELAY);
      callback.setState({ text: editor.current.editor.innerText.trim() });
    }
  }

  onScroll = (e) => {};

  onChangeTitle = (e) => {
    if (e.target.value.length < 100) {
      this.props.onDocumentsTitleChange(e.target.value);
      this.setState({ title: e.target.value });
    } else {
      message.error('글 제목은 100자 내로 입력해 주세요.');
    }
  };

  onReChange = (editorState) => {
    const content = editorState.getCurrentContent();
    const newText = content.getPlainText();
    this.props.onChangeText(newText);

    this.setState({
      editorState,
      text: newText,
    });
  };

  onHandlePastedText = (text, html) => {
    const { editorState } = this.state;
    if (text != null) {
      const blockMap = ContentState.createFromText(text.trim()).blockMap;
      const newState = Modifier.replaceWithFragment(
        editorState.getCurrentContent(),
        editorState.getSelection(),
        blockMap
      );

      const _editorState = EditorState.push(
        editorState,
        newState,
        'insert-fragment'
      );

      //const USER = JSON.parse(window.sessionStorage.getItem('user'));
      const user = this.props.user;
      const newText = _editorState.getCurrentContent().getPlainText();
      if (this.props.match.params.board.indexOf('sample') < 0) {
        if (user != null) {
          //유료회원
          if (user.status === 'valid' && user.item === 'premium') {
            this.fetchOrderUpdate();
            if (newText.length > 2000) {
              message.info(
                '서버의 부하 문제로 2000자까지만 입력하실 수 있습니다.'
              );
              const editorState = EditorState.moveFocusToEnd(
                EditorState.createWithContent(
                  ContentState.createFromText(
                    newText.substr(0, 1999).replace(/\n\n\n/g, '\n\n')
                  )
                )
              );
              this.onChange(editorState);
              if (textstimer) clearTimeout(textstimer);
              textstimer = setTimeout(this.timerTick, TEXTS_DELAY);
              if (lqinfostimer) clearTimeout(lqinfostimer);
              lqinfostimer = setTimeout(this.timerTickLqs, LQINFOS_DELAY);
              return true;
            }
            this.onChange(_editorState);
            if (textstimer) clearTimeout(textstimer);
            textstimer = setTimeout(this.timerTick, TEXTS_DELAY);
            if (lqinfostimer) clearTimeout(lqinfostimer);
            lqinfostimer = setTimeout(this.timerTickLqs, LQINFOS_DELAY);
            return true;
          }
          //무료회원
          else {
            if (newText.length > 300) {
              message.info(
                '글자수 300자 이상은 문장검사 서비스 결제 후 2000자까지 이용 하실 수 있습니다.'
              );
              const editorState = EditorState.moveFocusToEnd(
                EditorState.createWithContent(
                  ContentState.createFromText(
                    newText.substr(0, 299).replace(/\n\n\n/g, '\n\n')
                  )
                )
              );
              this.onChange(editorState);
              if (textstimer) clearTimeout(textstimer);
              textstimer = setTimeout(this.timerTick, TEXTS_DELAY);
              if (lqinfostimer) clearTimeout(lqinfostimer);
              lqinfostimer = setTimeout(this.timerTickLqs, LQINFOS_DELAY);
              return true;
            }
            this.onChange(_editorState);
            if (textstimer) clearTimeout(textstimer);
            textstimer = setTimeout(this.timerTick, TEXTS_DELAY);
            if (lqinfostimer) clearTimeout(lqinfostimer);
            lqinfostimer = setTimeout(this.timerTickLqs, LQINFOS_DELAY);
            return true;
          }
        } else {
          //비회원
          if (newText.length > 100) {
            message.info(
              '글자수 100자 이상은 회원가입 후 300자까지 이용 하실 수 있습니다.'
            );
            const editorState = EditorState.moveFocusToEnd(
              EditorState.createWithContent(
                ContentState.createFromText(
                  newText.substr(0, 99).replace(/\n\n\n/g, '\n\n')
                )
              )
            );
            this.onChange(editorState);
            if (textstimer) clearTimeout(textstimer);
            textstimer = setTimeout(this.timerTick, TEXTS_DELAY);
            if (lqinfostimer) clearTimeout(lqinfostimer);
            lqinfostimer = setTimeout(this.timerTickLqs, LQINFOS_DELAY);
            return true;
          }
        }
      }
      this.onChange(_editorState);
      if (textstimer) clearTimeout(textstimer);
      textstimer = setTimeout(this.timerTick, TEXTS_DELAY);
      if (lqinfostimer) clearTimeout(lqinfostimer);
      lqinfostimer = setTimeout(this.timerTickLqs, LQINFOS_DELAY);
    }

    return true;
  };

  onKeyBindingFn = (e) => {
    if (e.keyCode === 32) {
      this.setState({ keyStatus: 'SPACE' });
      if (textstimer) clearTimeout(textstimer);
      textstimer = setTimeout(this.timerTick, TEXTS_DELAY);
      if (lqinfostimer) clearTimeout(lqinfostimer);
      lqinfostimer = setTimeout(this.timerTickLqs, LQINFOS_DELAY);
      return getDefaultKeyBinding(e);
    } else if (e.keyCode === 46) {
      this.setState({ keyStatus: 'DELETE' });
      if (textstimer) clearTimeout(textstimer);
      textstimer = setTimeout(this.timerTick, TEXTS_DELAY);
      if (lqinfostimer) clearTimeout(lqinfostimer);
      lqinfostimer = setTimeout(this.timerTickLqs, LQINFOS_DELAY);
      return getDefaultKeyBinding(e);
    } else if (e.keyCode === 8) {
      this.setState({ keyStatus: 'BACKSPACE', change: true });
      return getDefaultKeyBinding(e);
    } else if (e.keyCode === 13) {
      this.setState({ keyStatus: 'ENTER', change: true });
      return getDefaultKeyBinding(e);
    } else if (e.keyCode > 189) {
      this.setState({ keyStatus: 'SPECIAL', change: true });
      return getDefaultKeyBinding(e);
    } else {
      this.setState({ keyStatus: 'ETC', change: true });
      return getDefaultKeyBinding(e);
    }
  };

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  componentDidMount() {
    this.updateWindowDimensions();
    this.focusEditor();

    //setInterval(this.timerTick, TEXTS_INTERVAL);
    //setInterval(this.timerTickWords, WORDS_INTERVAL);
    //setInterval(this.timerTickLqs, LQINFOS_INTERVAL);
    window.addEventListener('resize', this.updateWindowDimensions);

    const selection = this.state.editorState.getSelection();
    this.setState({ selection });
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  timerTickLqs = () => {
    //if (this.state.isChangeLqText) {
    const content = this.state.editorState.getCurrentContent();
    const newText = content.getPlainText();

    if (newText !== this.state.prevText) {
      this.props.onChangeLqInfosText(newText);
    }

    this.setState({ isChangeLqText: false, prevText: newText });
    //}
  };

  timerTickWords = () => {
    //if (this.state.isChangeWords) {
    //if (this.state.isChangeWords) {
    this.gradeCheck();
    this.props.onChangeText(editor.current.editor.innerText.trim());
    //this.setState({ isChangeWords: false });
    //}
    //}
  };

  timerTick = () => {
    const { editorState, prevBlocks } = this.state;
    const content = editorState.getCurrentContent();
    const contentBlocks = content.getBlocksAsArray();
    const prevContentBlocks = prevBlocks;
    const blockTexts = [];
    let blockKeys = [];
    if (prevContentBlocks) {
      blockKeys = contentBlocks
        .map((contentBlock) => {
          const key = contentBlock.getKey();
          const prevContentBlock = findOne(prevContentBlocks, key);
          const prevText =
            prevContentBlock != null ? prevContentBlock.getText() : '';
          if (contentBlock.getText() !== prevText) {
            blockTexts.push({
              blockKey: contentBlock.getKey(),
              blockText: contentBlock.getText(),
            });
          }
          return { blockKey: contentBlock.getKey() };
        })
        .filter((x) => x != null);
    } else {
      blockKeys = contentBlocks
        .map((contentBlock) => {
          blockTexts.push({
            blockKey: contentBlock.getKey(),
            blockText: contentBlock.getText(),
          });
          return { blockKey: contentBlock.getKey() };
        })
        .filter((x) => x != null);
    }

    if (blockTexts != null && blockTexts.length > 0) {
      this.props.onBlockKeyText(blockTexts, false);
    }
    this.props.onChangeBlockKey(blockKeys);
    this.setState({ isChangeText: false, prevBlocks: contentBlocks });
  };

  componentWillReceiveProps(nextProps) {
    const {
      div,
      broken1,
      broken2,
      wmenu,
      highlights,
      decos,
      searchFilter,
      selectMenu,
      synos,
      dialects,
      filters,
      multioptions,
      blocks,
      lqInfos,
      selectedItem,
      titleContents,
      textContents,
    } = nextProps;

    this.setState({ titleContents, textContents });

    if (
      this.props.div !== div ||
      (this.props.multioptions !== multioptions && selectMenu === '9') ||
      (this.props.selectMenu !== selectMenu && selectMenu === '7')
    ) {
      const contentBlocks = this.state.editorState
        .getCurrentContent()
        .getBlocksAsArray();
      const blockTexts = [];
      const blockKeys = contentBlocks
        .map((contentBlock) => {
          blockTexts.push({
            blockKey: contentBlock.getKey(),
            blockText: contentBlock.getText(),
          });
          return { blockKey: contentBlock.getKey() };
        })
        .filter((x) => x != null);
      this.props.onBlockKeyText(blockTexts, true);
      this.props.onChangeBlockKey(blockKeys);
      if (this.props.filters !== filters) {
        this.setState({ isLoading: true });
      }
    }

    if (broken1 != null && broken2 != null && wmenu != null) {
      this.setState({
        broken1,
        broken2,
        wmenu,
      });
    }
    if (selectMenu === '2' || selectMenu === '3' || selectMenu === '9') {
      if (highlights != null) {
        const _highlight = highlights.map((i) =>
          i.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&')
        );
        this.setState({
          editorState: EditorState.set(this.state.editorState, {
            decorator: gens.highlights.generateDecorator(
              _highlight,
              selectMenu
            ),
          }),
        });
      } else {
        this.setState({
          editorState: EditorState.set(this.state.editorState, {
            decorator: null,
          }),
        });
      }
    }

    if (selectMenu === '1') {
      if (blocks != null && blocks.length > 0) {
        //if (this.props.blocks !== blocks) {
        this.setState({
          editorState: EditorState.set(this.state.editorState, {
            //decorator: gens.blockHighlights.generateDecorator(blocks, activeIndex),
            decorator: gens.blockHighlights.generateDecorator(blocks),
          }),
        });
        //}
      } else {
        this.setState({
          editorState: EditorState.set(this.state.editorState, {
            decorator: null,
          }),
        });
      }
    }

    if (selectMenu === '4' || selectMenu === '7') {
      this.setState({
        editorState: EditorState.set(this.state.editorState, {
          decorator: null,
        }),
      });
    }

    if (selectMenu === '5') {
      if (decos != null) {
        this.setState({
          editorState: EditorState.set(this.state.editorState, {
            decorator: gens.spellchecks.generateDecorator(
              DecosFunc.decosBySearch(searchFilter, decos)
            ),
          }),
          selectedItem,
          decos,
          isChangeSelectedItem: true,
        });
      }
    }

    if (selectMenu === '6') {
      if (synos != null) {
        this.setState({
          editorState: EditorState.set(this.state.editorState, {
            decorator: gens.synonyms.generateDecorator(synos),
          }),
          isLoading: false,
        });
      }
    }

    if (selectMenu === '8') {
      if (dialects != null) {
        this.setState({
          editorState: EditorState.set(this.state.editorState, {
            decorator: gens.dialects.generateDecorator(dialects),
          }),
        });
      }
    }

    this.setState({ selectMenu, lqInfos });
  }

  gradeCheck = () => {
    //const USER = JSON.parse(window.sessionStorage.getItem('user'));
    const text = this.state.text;
    const user = this.props.user;
    if (this.props.match.params.board.indexOf('sample') < 0) {
      if (user != null) {
        //유료회원
        if (user.status === 'valid' && user.item === 'premium') {
          this.fetchOrderUpdate();
          if (text.length > 2000) {
            message.info(
              '서버의 부하 문제로 2000자까지만 입력하실 수 있습니다.'
            );
            const editorState = EditorState.moveFocusToEnd(
              EditorState.createWithContent(
                ContentState.createFromText(
                  text.substr(0, 1999).replace(/\n\n\n/g, '\n\n')
                )
              )
            );
            this.setState({ editorState });
            return true;
          }
          return true;
        }
        //무료회원
        else {
          if (text.length > 300) {
            message.info(
              '글자수 300자 이상은 문장검사 서비스 결제 후 2000자까지 이용 하실 수 있습니다.'
            );
            const editorState = EditorState.moveFocusToEnd(
              EditorState.createWithContent(
                ContentState.createFromText(
                  text.substr(0, 299).replace(/\n\n\n/g, '\n\n')
                )
              )
            );
            this.setState({ editorState });
            return true;
          }
          return true;
        }
      } else {
        //비회원
        if (text.length > 100) {
          message.info(
            '글자수 100자 이상은 회원 가입 후 300자까지 이용 하실 수 있습니다.'
          );
          const editorState = EditorState.moveFocusToEnd(
            EditorState.createWithContent(
              ContentState.createFromText(text.substr(0, 99))
            )
          );
          this.setState({ editorState });
          return true;
        }
        return true;
      }
    } else {
      const editorState = EditorState.moveFocusToEnd(
        EditorState.createWithContent(
          ContentState.createFromText(
            text.substr(0, 1999).replace(/\n\n\n/g, '\n\n')
          )
        )
      );
      this.setState({ editorState });
      return true;
    }
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.state.textContents !== prevState.textContents) {
      if (
        this.state.textContents != null &&
        this.state.textContents.trim() !== ''
      ) {
        const editorState = EditorState.createWithContent(
          ContentState.createFromText(
            this.state.textContents.replace(/\n\n/g, '\n')
          )
        );
        this.setState({
          editorState,
          text: this.state.textContents.replace(/\n\n/g, '\n'),
        });
      }
    }

    if (this.state.titleContents !== prevState.titleContents) {
      if (
        this.state.titleContents != null &&
        this.state.titleContents.trim() !== ''
      ) {
        this.setState({ title: this.state.titleContents });
      }
    }

    if (this.state.text !== prevState.text) {
      if (wordstimer) clearTimeout(wordstimer);
      wordstimer = setTimeout(this.timerTickWords, WORDS_DELAY);
      if (textstimer) clearTimeout(textstimer);
      textstimer = setTimeout(this.timerTick, TEXTS_DELAY);
      if (lqinfostimer) clearTimeout(lqinfostimer);
      lqinfostimer = setTimeout(this.timerTickLqs, LQINFOS_DELAY);

      this.setState({ change: true });
    }

    if (this.state.isChangeSelectedItem) {
      const { selectedItem, decos } = this.state;
      const _keys = decos
        .map((item, index) => {
          if (
            selectedItem != null &&
            item.orgStr === selectedItem.text &&
            parseInt(item.start) === parseInt(selectedItem.start)
          ) {
            return index;
          } else {
            return null;
          }
        })
        .filter((x) => x != null);

      if (_keys != null && _keys.length > 0) {
        if (this.myRef.current.scrollTop != null) {
          //this.myRef.current.scrollTop = 35 * _keys[0];
        }
      }

      this.setState({ isChangeSelectedItem: false });
    }

    var selectionState = this.state.editorState.getSelection();
    var anchorKey = selectionState.getAnchorKey();
    var currentContent = this.state.editorState.getCurrentContent();
    var currentContentBlock = currentContent.getBlockForKey(anchorKey);
    var start = selectionState.getStartOffset();
    var end = selectionState.getEndOffset();
    var selectedText = currentContentBlock.getText().slice(start, end);
    var prev_selectionState = prevState.editorState.getSelection();
    var prev_anchorKey = prev_selectionState.getAnchorKey();
    var prev_currentContent = prevState.editorState.getCurrentContent();
    var prev_currentContentBlock = prev_currentContent.getBlockForKey(
      prev_anchorKey
    );
    var prev_start = prev_selectionState.getStartOffset();
    var prev_end = prev_selectionState.getEndOffset();
    var prev_selectedText = prev_currentContentBlock
      .getText()
      .slice(prev_start, prev_end);
    if (selectedText !== prev_selectedText) {
      if (
        selectedText.trim() !== '' &&
        selectedText.trim().indexOf(' ') === -1 &&
        selectedText.trim() !== this.state.text.trim()
      ) {
        const { lqInfos } = this.state;
        if (lqInfos.length > 0) {
          const datas = lqInfos
            .filter((x) => x.blockKey === anchorKey)
            .flatMap((x) =>
              x.strRateandHomos.filter(
                (i) => i.name.indexOf(selectedText.trim()) >= 0
              )
            );
          if (datas != null && datas.length > 0) {
            notification.destroy();
            openNotification(this.props.match.params.board, datas);
          }
        } else {
          info();
        }
        if (this.state.selectMenu === '9') {
          this.props.onMultiLangSelectedText(selectedText);
        }
      } else {
        if (this.state.selectMenu === '9') {
          this.props.onMultiLangSelectedText('');
        }
        notification.destroy();
      }
    }

    if (this.state.selectMenu !== prevState.selectMenu) {
      this.props.onSelectedItem(null);
      const content = this.state.editorState.getCurrentContent();
      const blockKeys = content
        .getBlocksAsArray()
        .map((contentBlock) => {
          if (contentBlock.getText().trim() !== '') {
            return { blockKey: contentBlock.getKey() };
          } else {
            return null;
          }
        })
        .filter((x) => x != null);

      this.props.onChangeBlockKey(blockKeys);
    }

    if (prevProps.replaceItem.text !== this.props.replaceItem.text) {
      var line_selectionState = this.state.editorState.getSelection();
      var line_anchorKey = line_selectionState.getAnchorKey();
      var line_currentContent = this.state.editorState.getCurrentContent();
      var line_currentContentBlock = line_currentContent.getBlockForKey(
        line_anchorKey
      );
      var line = line_currentContentBlock
        .getText()
        .split('.')
        .filter((x) => x.indexOf(this.props.replaceItem.orgStr));

      const board = window.sessionStorage.getItem('board');
      const USER = JSON.parse(window.sessionStorage.getItem('user'));
      let datas = {
        status: '교체',
        source: this.props.replaceItem.orgStr,
        target: this.props.replaceItem.text,
      };

      if (USER != null) {
        datas = Object.assign({}, datas, { userId: USER.id });
      }
      if (board != null) {
        datas = Object.assign({}, datas, { board: parseInt(board) });
      }
      if (line[0] != null) {
        datas = Object.assign({}, datas, { line: line[0] });
      }
      this.fetchLogSave(datas);
      let content = this.state.editorState.getCurrentContent();
      const entityKey = Entity.create('MENTION', 'IMMUTABLE', {
        name: this.props.replaceItem.text,
      });

      let replaced = Modifier.replaceText(
        content,
        new SelectionState({
          anchorKey: this.props.replaceItem.blockKey,
          anchorOffset: this.props.replaceItem.start,
          focusKey: this.props.replaceItem.blockKey,
          focusOffset: this.props.replaceItem.end,
        }),
        this.props.replaceItem.text,
        null,
        entityKey
      );

      this.setState({
        editorState: EditorState.push(
          this.state.editorState,
          replaced,
          'replace-text'
        ),
        isReplaced: true,
      });
    }

    if (this.state.isReplaced) {
      //교체 저장
      //this.fetchLogSave({})
      this.props.onDisableItem(this.props.replaceItem.orgStr);
      this.props.onSelectedItem(null);
      if (textstimer) clearTimeout(textstimer);
      textstimer = setTimeout(this.timerTick, TEXTS_DELAY);
      if (lqinfostimer) clearTimeout(lqinfostimer);
      lqinfostimer = setTimeout(this.timerTickLqs, LQINFOS_DELAY);

      this.setState({ isReplaced: false });
    }
  }

  render() {
    const {
      editorState,
      broken1,
      broken2,
      wmenu,
      width,
      selectMenu,
    } = this.state;
    let _width;
    if (broken1 && broken2) {
      _width = width - wmenu;
    } else if (broken1 && !broken2) {
      _width = width - 250 - wmenu;
    } else {
      if (selectMenu === '7') {
        _width = (width - 250 - 80) / 2;
      } else if (selectMenu === '6') {
        _width = width - 750 - wmenu;
      } else {
        _width = width - 600 - wmenu;
      }
    }
    const isReadOnly =
      this.props.match.params.board.indexOf('sample') < 0 ? false : true;
    return (
      <Fragment>
        <div
          style={{
            margin: '15px',
            width: _width,
          }}>
          <div className="maincontent" style={{ width: _width - 30 }}>
            <div style={{ margin: '10px 15px 0px 20px' }}>
              <Input
                placeholder="글 제목을 입력해 주세요."
                size="large"
                style={styles.controls}
                name="title"
                value={this.state.title}
                onChange={this.onChangeTitle}
              />
            </div>
            <div
              className="mainwraper"
              ref={this.myRef}
              onScroll={this.onScroll}>
              <div
                className="innertube"
                style={styles.editor}
                onClick={this.focusEditor}>
                <Editor
                  ref={editor}
                  editorState={editorState}
                  onChange={this.onChange}
                  keyBindingFn={this.onKeyBindingFn}
                  handlePastedText={this.onHandlePastedText}
                  blockRenderMap={customRenderMap}
                  readOnly={isReadOnly}
                  placeholder="글을 작성하거나 붙여넣기 해주세요."
                />
              </div>
            </div>
          </div>
        </div>
        <Affix
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            zIndex: 999,
          }}>
          <BaseInfo />
        </Affix>
        <Drawer
          placement={this.state.placement}
          closable={true}
          onClose={this.onCloseDrawer}
          visible={this.state.visible}
          width={500}
          height="100%"
          style={{ padding: 0, margin: 0 }}
          bodyStyle={{ padding: 0, margin: 0 }}
          zIndex={1010}>
          <DecoDictionary word_no={this.state.word_no} />
        </Drawer>
      </Fragment>
    );
  }
}

/*
<div className="framecontentBottom" style={{ width: _width }}>
					<div className="innertube">
						<BaseInfo />
					</div>
				</div>
*/
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(CustomEditors));
